/*
  preorder-notice.js — universele pre-order-melding bij toevoegen aan het mandje.

  Toont eenmalig per product per sessie een korte pop-up zodra een pre-order-product
  in het mandje belandt, met de leverdatum die ook op de listing staat.

  BRON VAN WAARHEID = window.__PREORDER_NOTICE__.map (handle -> leverdatum), gevuld uit
  het shop-metafield candyonline.preorder_overrides door scripts_candy/preorder-window.php.
  Staat een product NIET in die map, dan gebeurt er niets. Zodra de voorraad binnen is
  haalt de watch-cron dat product uit de map -> geen pre-order-tekst en geen pop-up meer.
  Is de map leeg, dan rendert snippets/preorder-notice.liquid dit script helemaal niet.

  DETECTIE = PerformanceObserver op resource-entries, NIET een wrapper om window.fetch.
  Reden (gemeten 2026-09-14): een app-script (Kaching-achtig, geminificeerd) vervangt
  window.fetch NA ons en roept daarbij de originele fetch aan, waardoor een wrapper van
  ons wordt overgeslagen. Op de PDP bleven we wel in de keten, bij de tegel-quick-add
  ('/cart/add' zonder .js) niet — dus onbetrouwbaar. Resource-entries zien we hoe dan
  ook: fetch, XHR en beacon, ongeacht wie window.fetch heeft gekaapt.

  Na een add lezen we /cart.js en vergelijken met de vorige stand. Wat erbij is gekomen
  (nieuwe regel of hogere aantallen) is toegevoegd; zit daar een handle uit de map bij,
  dan tonen we de melding. /cart.js is meteen de betrouwbaarste bron voor titel en foto.
*/
(function () {
  'use strict';

  var CFG = window.__PREORDER_NOTICE__ || {};
  var MAP = (CFG && CFG.map) || {};
  if (!MAP || typeof MAP !== 'object' || !Object.keys(MAP).length) return;

  var SEEN_KEY = 'co_preorder_notice_seen';
  var SETTLE_MS = 450;   // adds bundelen (de strekdrop-LP vuurt product + 2 cadeaus achter elkaar)
  var OPEN_DELAY_MS = 250; // cart drawer / ATC-modal eerst hun animatie laten afmaken

  // ---------------------------------------------------------------- sessie-geheugen
  // sessionStorage kan gooien (private mode, geblokkeerde opslag) -> altijd try/catch.
  function seen() {
    try {
      var raw = window.sessionStorage.getItem(SEEN_KEY);
      var o = raw ? JSON.parse(raw) : null;
      return (o && typeof o === 'object') ? o : {};
    } catch (e) { return {}; }
  }
  function markSeen(handle) {
    try {
      var o = seen();
      o[handle] = 1;
      window.sessionStorage.setItem(SEEN_KEY, JSON.stringify(o));
    } catch (e) { /* geen opslag: dan toont hij vaker, nooit minder */ }
  }

  // ---------------------------------------------------------------- pop-up bedienen
  var root, elImg, elText, elDate, elOk, lastFocus, openTimer;

  function grab() {
    if (root && document.body.contains(root)) return true;
    root = document.getElementById('po-notice');
    if (!root) return false;
    elImg = root.querySelector('#po-notice-img');
    elText = root.querySelector('#po-notice-text');
    elDate = root.querySelector('#po-notice-date');
    elOk = root.querySelector('#po-notice-ok');
    root.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-po-close]')) {
        e.preventDefault();
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && root.classList.contains('is-open')) close();
    });
    return true;
  }

  function open(info) {
    if (!grab()) return;
    var title = info.title || 'Dit product';
    if (info.image) {
      elImg.src = info.image;
      elImg.alt = title;
      elImg.hidden = false;
    } else {
      elImg.hidden = true;
      elImg.removeAttribute('src');
    }
    // Titel via textContent zodat een productnaam met < of & nooit als HTML landt.
    elText.innerHTML = 'Je hebt <strong></strong> vastgelegd. We versturen je bestelling zodra de nieuwe voorraad binnen is.';
    elText.querySelector('strong').textContent = title;
    elDate.textContent = info.date;

    try { lastFocus = document.activeElement; } catch (e) { lastFocus = null; }
    root.hidden = false;
    void root.offsetWidth; // reflow forceren zodat de open-transitie echt speelt
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (elOk) {
      try { elOk.focus({ preventScroll: true }); } catch (e) { elOk.focus(); }
    }
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      if (root && !root.classList.contains('is-open')) root.hidden = true;
    }, 260);
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocus = null;
  }

  function show(info) {
    if (seen()[info.handle]) return;
    markSeen(info.handle);
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () { open(info); }, OPEN_DELAY_MS);
  }

  // ---------------------------------------------------------------- mandje lezen
  function itemImage(it) {
    if (it.featured_image && it.featured_image.url) return it.featured_image.url;
    if (typeof it.image === 'string' && it.image) return it.image;
    return '';
  }

  // Regels samenvatten als key -> aantal, zodat we kunnen zien wat erbij kwam.
  function snapshot(cart) {
    var out = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var k = it.key || (it.variant_id + ':' + i);
      out[k] = { qty: it.quantity || 0, item: it };
    }
    return out;
  }

  var known = null; // stand van het mandje zoals wij die het laatst zagen

  function readCart() {
    // Bewust XHR: als een app-script window.fetch heeft gekaapt, blijft dit werken.
    return new Promise(function (resolve) {
      try {
        var x = new XMLHttpRequest();
        x.open('GET', '/cart.js?_po=' + Date.now(), true);
        x.setRequestHeader('Accept', 'application/json');
        x.onload = function () {
          try { resolve(JSON.parse(x.responseText)); } catch (e) { resolve(null); }
        };
        x.onerror = function () { resolve(null); };
        x.send();
      } catch (e) { resolve(null); }
    });
  }

  function afterAdd() {
    readCart().then(function (cart) {
      if (!cart) return;
      var now = snapshot(cart);
      if (known === null) { known = now; return; } // eerste meting: alleen ijken
      var match = null;
      for (var k in now) {
        if (!Object.prototype.hasOwnProperty.call(now, k)) continue;
        var was = known[k] ? known[k].qty : 0;
        if (now[k].qty <= was) continue;            // niets erbij op deze regel
        var it = now[k].item;
        var handle = it.handle || '';
        if (!MAP[handle]) continue;                 // geen pre-order-product
        match = { handle: handle, date: MAP[handle], title: it.product_title || it.title || '', image: itemImage(it) };
        break;                                      // hoogstens een melding per add
      }
      known = now;
      if (match) show(match);
    });
  }

  // ---------------------------------------------------------------- add detecteren
  var settleTimer;
  function noteAdd() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(afterAdd, SETTLE_MS);
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  readCart().then(function (cart) { known = snapshot(cart); });

  if (typeof window.PerformanceObserver === 'function') {
    try {
      var po = new PerformanceObserver(function (list) {
        var e = list.getEntries();
        for (var i = 0; i < e.length; i++) {
          if (isCartAdd(e[i].name)) { noteAdd(); return; }
        }
      });
      po.observe({ type: 'resource', buffered: true });
    } catch (e) { /* oudere browser: valt terug op de haken hieronder */ }
  }

  // Vangnet voor browsers zonder PerformanceObserver-resource-support. Dubbel afvuren
  // is onschadelijk: noteAdd debounct en show() toont per handle maar een keer.
  try {
    var prevFetch = window.fetch;
    if (typeof prevFetch === 'function') {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = prevFetch.apply(this, arguments);
        if (isCartAdd(url) && p && typeof p.then === 'function') {
          p.then(function (r) { if (r && r.ok) noteAdd(); }, function () {});
        }
        return p;
      };
    }
  } catch (e) {}

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__poUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      if (isCartAdd(self.__poUrl)) {
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) noteAdd();
        });
      }
      return origSend.apply(this, arguments);
    };
  } catch (e) {}

  // ---------------------------------------------------------------- handmatige haak
  // window.showPreorderNotice('<handle>') -> melding forceren, ook al is hij deze sessie
  // al getoond. Handig om te testen.
  window.showPreorderNotice = function (handle, opts) {
    var date = MAP[handle];
    if (!date) return false;
    opts = opts || {};
    open({ handle: handle, date: date, title: opts.title || '', image: opts.image || '' });
    return true;
  };
  window.__preorderNoticeMap = MAP;
})();
